export const DOCUMENT_TYPE_VEHICLE_TYPE = 'commerce.vehicleType';
